import Navbar from './components/Navbar';
import HeroSection from './components/HeroSection';
import CategorySection from './components/CategorySection';
import WhatIsSection from './components/WhatIsSection';
import BenefitsSection from './components/BenefitsSection';
import HowItWorksSection from './components/HowItWorksSection';
import SafetySection from './components/SafetySection';
import FAQSection from './components/FAQSection';
import ArticlesSection from './components/ArticlesSection';
import Footer from './components/Footer';

const siteUrl = import.meta.env.VITE_SITE_URL || 'https://superbuysheet.cyou';

export default function Home() {
  return (
    <main className="min-h-screen bg-background-50">
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{
          __html: JSON.stringify({
            '@context': 'https://schema.org',
            '@type': 'WebPage',
            name: 'Superbuy Sheet 2026 — Find Better Products Faster With Organized Shopping Resources',
            description: 'Discover carefully organized Superbuy Sheet resources, product research guides, QC photo explanations, category collections, and international shopping strategies. Make smarter buying decisions with structured product information.',
            url: siteUrl + '/',
            inLanguage: 'en',
            isPartOf: {
              '@type': 'WebSite',
              name: 'Superbuy Sheet',
              url: siteUrl + '/',
            },
            publisher: {
              '@type': 'Organization',
              name: 'Superbuy Sheet',
              url: siteUrl + '/',
            },
          }),
        }}
      />
      <Navbar />
      <HeroSection />
      <CategorySection />
      <WhatIsSection />
      <BenefitsSection />
      <HowItWorksSection />
      <SafetySection />
      <FAQSection />
      <ArticlesSection />
      <Footer />
    </main>
  );
}